export const APP_IS_OFFLINE = 'APP/APP_IS_OFFLINE'
export const APP_IS_ONLINE = 'APP/APP_IS_ONLINE'
